import {Recurso, UseCaseRecursoAsync} from 'lib.common/dist/CleanArch';
import {ErrExterno} from 'lib.common/dist/errorHandler';
import {
   DeleteDatabasesInParams,
   DeleteDatabasesOutParams
} from '../../utils/params/DeleteDatabasesParams';
import {GestionarAppDbsRepository} from '../repository/GestionarAppDbsRepository';

export class DeleteDatabasesUseCase extends UseCaseRecursoAsync<
   DeleteDatabasesInParams,
   DeleteDatabasesOutParams
> {
   constructor(public repo: GestionarAppDbsRepository) {
      super();
   }

   async call(input: DeleteDatabasesInParams): Promise<Recurso<DeleteDatabasesOutParams>> {
      try {
         let result = await this.repo.deleteDbs(input);
         return result;
      } catch (error) {
         const errorCapa = new ErrExterno(error as Error);
         return Recurso.fromError<DeleteDatabasesOutParams>(errorCapa);
      }
   }
}
